<template>
  <v-dialog :value="isOpen"
    persistent
    scrollable
    fullscreen
    no-click-animation
    :style="borderStyle"
    content-class="image-browser">
    <v-card>
      <image-browser-header :browserName="browserName" @closeModal="closeModal"/>
      <v-card-text class="fill-height image-browser-card-text">
        <v-container fluid class="pa-0 image-browser-container fill-height">
          <component v-if="isOpen" 
          :is="bodyComponent" 
          ref="browserBody" 
          :isOpen="isOpen"/>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import hasImageBrowserBody from "../mixins/HasImageBrowserBody";

export default {
  name: "imageBrowser",
  mixins: [hasImageBrowserBody],
  computed: {
    isOpen() {
      return !!this.imageBrowserContext;
    },
  },
  methods: {
    closeModal() {
      this.$store.dispatch("closeImageBrowser");
      let examToReload = this.$store.getters.openedExams;
      this.$store.dispatch("setOpenedExams", []);
      this.$store.dispatch("setOpenedExams", examToReload);
    }
  }
};
</script>